import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators} from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
declare var CKEDITOR: any;

@Component({
  selector: 'app-course-create',
  templateUrl: './course-create.component.html',
  styleUrls: ['./course-create.component.scss']
})
export class CourseCreateComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  message = null;
  class = null;
  action = null;
  submitted = false;
  public courseForm: FormGroup;
  public course = [];

  ngOnInit() {
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    
      // console.log(`${id}`);
      this.http.get<any>(this.api_endpoint+'/coursebyid/' + `${id}`).subscribe(
        data => {
          // console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            // CKEDITOR.instances['editor-9'].setData('dgsdg');
            this.courseForm.patchValue({
              _id: data.data._id,
              department: data.data.department,
              course: data.data.course,
              duration: data.data.duration,
              program_details: data.data.program_details,
              slidertitle: data.data.slidertitle,
              sliderimage: data.data.sliderimage,
              sliderdescription: data.data.sliderdescription,
              uniqueAdvantage: data.data.uniqueAdvantage,
              eligibility: data.data.eligibility,
              jobOpportunities: data.data.jobOpportunities,
              industryInternship: data.data.industryInternship,
              courselink: data.data.courselink,
              priority: data.data.priority,
              vision: data.data.vision,
              mission: data.data.mission,
              hodimage: data.data.hodimage,
              hodname: data.data.hodname,
              hodqualification: data.data.hodqualification,
              hodmessage: data.data.hodmessage,
              entry: data.data.entry,
              addoncertfication: data.data.addoncertfication,
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });

    this.courseForm = this.formBuilder.group({
      department: ['', Validators.required],
      course: ['', Validators.required],
      duration: ['', Validators.required],
      program_details: ['', Validators.required],
      slidertitle: ['', Validators.required],
      sliderimage: ['', Validators.required],
      sliderdescription: [''],
      uniqueAdvantage: [''],
      eligibility: [''],
      jobOpportunities: [''],
      industryInternship: [''],
      vision: [''],
      mission: [''],
      hodimage: [''],
      hodname: [''],
      hodqualification: [''],
      hodmessage: [''],
      entry: [''],
      priority: ['', Validators.required],
      addoncertfication: ['', Validators.required],
      courselink: ['', Validators.required],
      _id: ['']
    })
  }

  get f() { return this.courseForm.controls; }

  onFormSubmit() {
    
    this.submitted = true;

    if (this.courseForm.invalid) {
      return;
    }

    if(this.action == 'Submit'){
    
    var data = {
      "department" : this.courseForm.value.department,
      "course" : this.courseForm.value.course,
      "duration" : this.courseForm.value.duration,
      "program_details" : this.courseForm.value.program_details,
      "slidertitle" : this.courseForm.value.slidertitle,
      "courselink" : this.courseForm.value.courselink,
      "sliderimage": this.courseForm.value.sliderimage,
      "sliderdescription": this.courseForm.value.sliderdescription,
      "uniqueAdvantage": this.courseForm.value.uniqueAdvantage,
      "eligibility": this.courseForm.value.eligibility,
      "jobOpportunities": this.courseForm.value.jobOpportunities,
      "industryInternship": this.courseForm.value.industryInternship,
      "priority": this.courseForm.value.priority,
      "vision": this.courseForm.value.vision,
      "mission": this.courseForm.value.mission,
      "hodimage": this.courseForm.value.hodimage,
      "hodname": this.courseForm.value.hodname,
      "hodqualification": this.courseForm.value.hodqualification,
      "hodmessage": this.courseForm.value.hodmessage,
      "entry": this.courseForm.value.entry,
      "addoncertfication": this.courseForm.value.addoncertfication,
      "admin" : sessionStorage.getItem('adminName'),
    };
    console.log(data);
    this.http.post<any>(this.api_endpoint+'/courses', data).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/course/list-page');
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured."+err);
      }
    });
  }else{
    var data1 = {
      "department" : this.courseForm.value.department,
      "course" : this.courseForm.value.course,
      "duration" : this.courseForm.value.duration,
      "program_details" : this.courseForm.value.program_details,
      "slidertitle" : this.courseForm.value.slidertitle,
      "courselink" : this.courseForm.value.courselink,
      "sliderimage": this.courseForm.value.sliderimage,
      "sliderdescription": this.courseForm.value.sliderdescription,
      "uniqueAdvantage": this.courseForm.value.uniqueAdvantage,
      "eligibility": this.courseForm.value.eligibility,
      "jobOpportunities": this.courseForm.value.jobOpportunities,
      "industryInternship": this.courseForm.value.industryInternship,
      "vision": this.courseForm.value.vision,
      "mission": this.courseForm.value.mission,
      "hodimage": this.courseForm.value.hodimage,
      "hodname": this.courseForm.value.hodname,
      "hodqualification": this.courseForm.value.hodqualification,
      "hodmessage": this.courseForm.value.hodmessage,
      "entry": this.courseForm.value.entry,
      "priority": this.courseForm.value.priority,
      "addoncertfication": this.courseForm.value.addoncertfication,
      "admin" : sessionStorage.getItem('adminName'),
      "_id" : this.courseForm.value._id,
    };
      // console.log(data1);     
      this.http.put<any>(this.api_endpoint+'/courses/', data1).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        } 
        this.router.navigateByUrl('/adminhkbkcms/course/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
  }
  }

}
